import React from 'react';
import CustomIcon from '../Common/CustomIcon/CustomIcon';
import ChonkyFileBrowser from './Chonky/ChonkyFileBrowser';
import {
	ChonkyActions,
	ChonkyIconName,
} from 'chonky';
import listingStyles from './ListingsTable.module.css';
import {
	VCL_RESOLUTION_VERTICAL,
} from './utils/vclUtils';

class VisualContentLoopsTableView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			allRowsSelected:    false,
			itemsPerPage:       50,
			page:               1,
			searchQuery:        '',
			selectedLoops:      [],
			sortColumn:         'name',
			sortDirection:      'asc',
			visualContentLoops: props.visualContentLoops,
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.visualContentLoops !== this.props.visualContentLoops) {
			const {
				selectedLoops, searchQuery,
			} = this.state;
			const currentUUIDSet = new Set(this.props.visualContentLoops.map((l) => {
				return l.uuid;
			}));
			const filteredSelectedLoops = selectedLoops.filter((uuid) => {
				return currentUUIDSet.has(uuid);
			});
			const updatedLoops = this.props.visualContentLoops.map((loop) => {
				return {
					...loop,
					isChecked: filteredSelectedLoops.includes(loop.uuid),
				};
			});
			const filteredBySearch = updatedLoops.filter((loop) => {
				return loop.name.toLowerCase().includes(searchQuery.toLowerCase());
			});
			const allFilteredSelected = filteredBySearch.length > 0 && filteredBySearch.every((loop) => {
				return filteredSelectedLoops.includes(loop.uuid);
			});
			this.setState({
				visualContentLoops: updatedLoops,
				selectedLoops:      filteredSelectedLoops,
				allRowsSelected:    allFilteredSelected,
			});
		}
	}

	handleSearch = (e) => {
		this.setState({
			searchQuery:     e.target.value,
			allRowsSelected: false, // Reset selection state when search changes
		});
	}

	clearSearch = () => {
		this.setState({
			searchQuery:     '',
			allRowsSelected: false,
		});
	}

	handleSort = (column) => {
		const {
			sortColumn, sortDirection,
		} = this.state;
		const newDirection = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';

		this.setState({
			sortColumn:    column,
			sortDirection: newDirection,
		});
	}

	toggleSelectAllRows = () => {
		const filteredLoops = this.getFilteredLoops();
		const {
			visualContentLoops, selectedLoops,
		} = this.state;

		// Check if all filtered rows are currently selected
		const allFilteredSelected = filteredLoops.every((loop) => {
			return selectedLoops.includes(loop.uuid);
		});

		let newSelectedLoops = [ ...selectedLoops, ];

		if (allFilteredSelected) {
			// Unselect all filtered rows
			filteredLoops.forEach((loop) => {
				const index = newSelectedLoops.indexOf(loop.uuid);
				if (index > -1) {
					newSelectedLoops.splice(index, 1);
				}
			});
		} else {
			// Select all filtered rows
			filteredLoops.forEach((loop) => {
				if (!newSelectedLoops.includes(loop.uuid)) {
					newSelectedLoops.push(loop.uuid);
				}
			});
		}

		// Update the isChecked property for all visualContentLoops
		const newVisualContentLoops = visualContentLoops.map((loop) => {
			return {
				...loop,
				isChecked: newSelectedLoops.includes(loop.uuid),
			};
		});

		// Check if all filtered rows are selected after the change
		const newAllFilteredSelected = filteredLoops.every((loop) => {
			return newSelectedLoops.includes(loop.uuid);
		});

		this.setState({
			visualContentLoops: newVisualContentLoops,
			selectedLoops:      newSelectedLoops,
			allRowsSelected:    newAllFilteredSelected,
		});
	}

	toggleSelectSingleRow = (loopUUID) => {
		const {
			visualContentLoops, selectedLoops,
		} = this.state;

		const newVisualContentLoops = visualContentLoops.map((loop) => {
			return loop.uuid === loopUUID ? {
				...loop,
				isChecked: !loop.isChecked,
			} : loop;
		}
		);

		const newSelectedLoops = [ ...selectedLoops, ];
		const index = newSelectedLoops.indexOf(loopUUID);

		if (index > -1) {
			newSelectedLoops.splice(index, 1);
		} else {
			newSelectedLoops.push(loopUUID);
		}

		// Check if all filtered rows are selected
		const filteredLoops = this.getFilteredLoops();
		const allFilteredSelected = filteredLoops.every((loop) => {
			return loop.uuid === loopUUID ? !loop.isChecked : newSelectedLoops.includes(loop.uuid);
		}
		);

		this.setState({
			visualContentLoops: newVisualContentLoops,
			selectedLoops:      newSelectedLoops,
			allRowsSelected:    allFilteredSelected,
		});
	}

	getFilteredAndSortedLoops = () => {
		const {
			visualContentLoops, searchQuery, sortColumn, sortDirection,
		} = this.state;

		// Filter by search query
		let filteredLoops = visualContentLoops.filter((loop) => {
			return loop.name.toLowerCase().includes(searchQuery.toLowerCase());
		}
		);

		// Sort
		filteredLoops.sort((a, b) => {
			let aVal = a[sortColumn];
			let bVal = b[sortColumn];

			if (sortDirection === 'asc') {
				return aVal > bVal ? 1 : -1;
			}
			return aVal < bVal ? 1 : -1;

		});

		return filteredLoops;
	}

	getFilteredLoops = () => {
		const {
			visualContentLoops, searchQuery,
		} = this.state;

		// Filter by search query only - let VultureTable handle sorting
		let filteredLoops = visualContentLoops.filter((loop) => {
			return loop.name.toLowerCase().includes(searchQuery.toLowerCase());
		}
		);

		return filteredLoops;
	}

	render() {
		const {
			visualContentLoop,
		} = this.props;

		if (visualContentLoop) {
			return null;
		}

		const {
			selectedLoops,
			searchQuery,
			page,
			itemsPerPage,
		} = this.state;

		const filteredLoops = this.getFilteredLoops();

		const previousPageAvailable = page > 1;
		const nextPageAvailable = (page * itemsPerPage) < filteredLoops.length;

		// Calculate if all filtered rows are selected
		const allFilteredRowsSelected = filteredLoops.length > 0 && filteredLoops.every((loop) => {
			return selectedLoops.includes(loop.uuid);
		});

		const checkIcon = <div className={listingStyles.iconWrapper}><CustomIcon icon="check"/></div>;

		const disabledSquare = (
			<div className={listingStyles.disabledSquare}>
				<div className={listingStyles.checkboxIcon}>
					<CustomIcon icon="check"/>
				</div>
			</div>
		);

		const activeCheckbox = (
			<div className={listingStyles.activeCheckbox}>
				<div className={listingStyles.checkboxIcon}>
					<CustomIcon icon="check"/>
				</div>
			</div>
		);

		const chonkyFiles = filteredLoops.map((loop) => {
			const totalSlots = loop.slots || 0;
			const totalDurationSeconds = Math.round(loop.totalDuration || 0);
			// Vertical default matches getEffectiveVCLResolution's fallback in the editor
			const resolution = loop.resolution || VCL_RESOLUTION_VERTICAL;

			// Format duration as MM:SS
			const minutes = Math.floor(totalDurationSeconds / 60);
			const seconds = String(totalDurationSeconds % 60).padStart(2, '0');
			const totalDuration = `${minutes}:${seconds}`;

			return {
				id:    loop.uuid,
				name:  loop.name,
				isDir: false,
				loop,
				totalSlots,
				totalDuration,
				resolution,
				// Searchable haystack for searchAllColumns (the name column accessor returns JSX)
				assignmentData: {
					name: loop.name,
					resolution,
				},
			};
		});

		const chonkyFileMap = {
			root: {
				id:          'root',
				name:        'Visual Content Loops',
				isDir:       true,
				childrenIds: chonkyFiles.map((f) => {
					return f.id;
				}),
				parentId: null,
			},
			...Object.fromEntries(chonkyFiles.map((f) => {
				return [ f.id, f, ];
			})),
		};

		const injectedColumns = [
			{
				id:       'name',
				label:    'Name',
				accessor: (f) => {
					return (
						<div
							style={{
								cursor: 'pointer',
							}}
							onClick={(e) => {
								e.stopPropagation();
								this.props.loadVisualContentLoop(f.id);
							}}
						>
							{f.name}
						</div>
					);
				},
			},
			{
				id:       'totalSlots',
				label:    'Total Slots',
				center: true,
				accessor: (f) => {
					return f.totalSlots;
				},
			},
			{
				id:       'totalDuration',
				label:    'Total Duration',
				center: true,
				accessor: (f) => {
					return f.totalDuration;
				},
			},
			{
				id:       'resolution',
				label:    'Resolution',
				center: true,
				accessor: (f) => {
					return f.resolution;
				},
			},
		];

		const injectedActions = [
			{
				id:      'custom_injected_create',
				name:    'New Loop',
				icon:    'visual_content_loop_icon_down_alligned',
				handler: () => {
					if (this.props.createNewLoop) this.props.createNewLoop();
				},
			},
			{
				id:      'custom_injected_delete',
				name:    'Delete Selected',
				icon:    ChonkyIconName.trash,
				handler: ({
					selection,
				}) => {
					if (!selection || selection.length === 0) return;
					if (this.props.deleteSelectedLoops) this.props.deleteSelectedLoops(selection);
				},
			},
		];

		return (
			<>
				{/* Header with Search and New Loop Button */}
				<div style={{
					display:        'flex',
					justifyContent: 'space-between',
					alignItems:     'center',
					marginBottom:   '5px',
				}}>
					<div></div>

					<div style={{
						display:    'flex',
						gap:        '10px',
						alignItems: 'center',
					}}>

						{/* Loop Assignments Button */}
						<button
							className="button"
							data-test-id="loopAssignmentsButton"
							onClick={this.props.openLoopAssignments}
							style={{
								display:    'flex',
								alignItems: 'center',
								gap:        '5px',
							}}
						>
							<CustomIcon icon="list" />
							Loop Assignments
						</button>
					</div>
				</div>

				{/* Chonky Listing */}
				<div style={{
					padding: '8px',
					flex: 1,
					display: 'flex',
					flexDirection: 'column',
					minHeight: 0,
				}}>
					<ChonkyFileBrowser
						mode="visualContentLoops"
						app={this.props.app}
						readOnly={true}
						addSelectAllToggleAction={true}
						accountUUID={this.props.accountUUID}
						injectedFileMap={chonkyFileMap}
						hideEdit
						injectedColumns={injectedColumns}
						injectedActions={injectedActions}
						onInjectedFileOpen={(file) => {
							this.props.loadVisualContentLoop(file.id);
						}}
						onInjectedEdit={(file) => {
							if (this.props.editLoopModal) this.props.editLoopModal(file.id);
						}}
						onInjectedDelete={(file) => {
							if (this.props.deleteSingleLoop) this.props.deleteSingleLoop(file.id);
						}}
						searchAllColumns={true}
						injectedColumnDefaults={{
							name: '260px',
							resolution: '160px',
							totalSlots: '120px',
							totalDuration: '160px',
						}}
						defaultFileViewActionId={ChonkyActions.EnableListView.id}
						hideListViewOptions={true}
					/>
				</div>

				{/* Results Summary */}
				<div style={{
					marginTop: '0px',
					fontSize:  '14px',
					color:     '#666',
				}}>
					Showing {filteredLoops.length} of {this.state.visualContentLoops.length} visual content loops
					{selectedLoops.length > 0 && ` (${selectedLoops.length} selected)`}
				</div>
			</>
		);
	}
}

export default VisualContentLoopsTableView;
